import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import './AllTrainingCompleted.css';
import Zoom from '@mui/material/Zoom';

export default function AllTrainingCompleted(props) {
    return (<div>
        <div role="presentation" className="MuiDialog-root MuiModal-root css-zw3mfo-MuiModal-root-MuiDialog-root">
            <div aria-hidden="true" className="MuiBackdrop-root css-yiavyu-MuiBackdrop-root-MuiDialog-backdrop" style={{ opacity: 1, transition: 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms' }}></div>
            <div tabindex="0" data-testid="sentinelStart"></div>
            <div className='allTrainingContent'>
                <div className='icon'>
                    <Zoom in={true} timeout={500} easing={'ease-out' }>
                        <img src='images/goldstar.png' style={{ height: '100px', width: '100px' }} />
                    </Zoom>
                </div>
                <div className='content'>
                    <div style={{ fontWeight: 'bold' }}>Congratulations!</div>
                    <div style={{ marginTop: '10px' }}>You have finished setting up your account.</div>
                    <div style={{ marginTop: '10px' }}>You can now view and claim orders.</div>
                    <div style={{ marginTop: '20px' }}>We are always here for you. If you have any other questions, concerns, suggestions, feedback, or good jokes please use the Contact page to get in touch!</div>

                    <div style={{ marginTop: '30px', paddingBottom:'10px' }}>
                        <Button sx={{ backgroundColor: 'var(--sipzee-green)' }} onClick={props.onClose}>Close</Button>
                    </div>
                </div>
            </div>


        </div>

        <div tabindex="0" data-testid="sentinelEnd"></div>

    </div>)
    
}